import type { FeatureConfig } from '@seek/hirer-feature-toggle';

export const FEATURE_TOGGLE_CART_EDIT_FLOW = 'feature-toggle-cart-edit-flow';

export const features: FeatureConfig[] = [
  {
    key: FEATURE_TOGGLE_CART_EDIT_FLOW,
    name: 'Card edit flow',
    description: 'Card edit flow feature toggle',
    variants: [true, false],
    fallback: false,
  },
];
